




















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Vue } from 'vue-property-decorator';

import 'vue-select/dist/vue-select.css';
import { UploadCloudIcon } from 'vue-feather-icons';
import { AdmiralException, ImportedFivFile } from 'admiral-core';
import { PolicyApi } from '@/services/PolicyApi';
import ConfirmPolicyImportModal from '@/views/pages/fivgoals/ConfirmPolicyImportModal.vue';

@Component({
  components: {
    ConfirmPolicyImportModal,
    UploadCloudIcon,
  },
})
export default class ImportPoliciesButton extends Vue {
  importedFivFile: ImportedFivFile | null = null;

  async handleImportPoliciesUpload() {
    const files = (this.$refs.file as any).files;
    const formData = new FormData();

    formData.append('file', files[0]);
    this.$Progress.start();

    try {
      const responseUpload = await PolicyApi.uploadFromPoliciesFiv(formData);

      this.importedFivFile = responseUpload.data;

      (this.$refs['confirm-policy-import-modal'] as any).$refs['confirm-policy-import'].show();
    } catch (e: any) {
      const exception = e.response?.data as AdmiralException;
      // if (exception.errors) {
      //   const errors = exception.errors;
      //   this.error = 'Beim Hochladen des Geschäftplans ist etwas schiefgelaufen.';
      //
      //   if (errors['TooManyFiles']) {
      //     this.error = 'Es können maximal 2 Dateien gleichzeitig hochgeladen werden.';
      //   } else if (errors['CorruptedExcel']) {
      //     this.error =
      //       'FIV-exportierte Dateien dürfen nicht beabreitet werden. Bitte den Geschäftsplan unbearbeitet hochladen.  ';
      //   } else if (errors['InvalidBusinessPlanReport']) {
      //     this.error =
      //       'Ungültiger Geschäftsplan: Folgende Geschäftspläne sind zulässig: ' +
      //       errors['InvalidBusinessPlanReport'];
      //   }
      // }
    } finally {
      (this.$refs.file as HTMLFormElement).value = '';
      this.$Progress.finish();
    }
  }
  openFileUpload() {
    (this.$refs.file as HTMLFormElement).click();
  }
}
